import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LogoutComponent } from "./auth/logout/logout.component";
import { BookDashNewComponent } from "./book-dash-new/book-dash-new.component";
import { ViewInvoiceComponent } from "./Sales/view-invoice/view-invoice.component";
import { PickupAssignComponent } from "./pickup-assign/pickup-assign.component";
import { BidTransporterComponent } from "./bid-transporter/bid-transporter.component";
import { RepairsAndMaintenanceComponent } from "./repairs-and-maintenance/repairs-and-maintenance.component";
import { BidTransporterPickupRequestComponent } from "./bid-transporter-pickup-request/bid-transporter-pickup-request.component";
import { InternetconnectivityComponent } from "./internetconnectivity/internetconnectivity.component";
import { LogoutNewComponent } from "./auth/logout-new/logout-new.component";
import { environment } from "../environments/environment";
import { SsologinComponent } from "./theme/ssologin/ssologin.component";

const routes: Routes = [
  { path: "", redirectTo: environment.apiUrl == 'https://sawariya.ifreightbox.net/' || environment.apiUrl == 'https://ximble.ifreightbox.net/' ? "index2" : "index", pathMatch: "full" },
  { path: "login", loadChildren: "./auth/auth.module#AuthModule" },
  { path: "resetpassword", loadChildren: "./components/custompassword/resetpassword.module#ResetPasswordModule", },
  { path: "setpassword", loadChildren: "./components/custompassword/resetpassword.module#ResetPasswordModule", },
  { path: "logout", component: LogoutComponent },
  { path: "logout-new", component: LogoutNewComponent },
  { path: "LiveTracking", loadChildren: "./LiveTracking/LiveTracking.module#LiveTrackingModule", },
  { path: "LiveTracking_ByOrder", loadChildren: "./LiveTracking_ByOrder/LiveTracking_ByOrder.module#LiveTracking_ByOrderModule", },
  { path: "LiveOrderTrack", loadChildren: "./Orders/live-order-track/live-order-track.module#LiveOrderTrackModule", },
  { path: "lm_orderReturnApprove", loadChildren: "./WithoutLogin/lm_orderReturnApprove/lm_orderReturnApprove.module#lm_orderReturnApproveModule", },
  { path: "check-list", loadChildren: "./check-list/check-list.module#CheckListModule", },
  { path: "trackbyno", loadChildren: "./track-by-no/track-by-no.module#TrackByNoModule", },
  { path: "bookdashnew", component: BookDashNewComponent },
  { path: "ViewInvoice", component: ViewInvoiceComponent },
  //add vithujan 14-06-2022
  { path: "pickup-assign", component: PickupAssignComponent },
  { path: "bid-transporter", component: BidTransporterComponent },
  { path: "repair-and-maintenance", component: RepairsAndMaintenanceComponent },
  { path: "print-invoice", loadChildren: "./print-invoice/print-invoice.module#PrintInvoiceModule", },
  { path: "THCAdvanceApproveReject", loadChildren: "./THCAdvanceApproveReject/THCAdvanceApproveReject.module#THCAdvanceApproveRejectModule", },
  //added by vithujan 29-12-2023 - Siddarth
  { path: "courier-tracking", loadChildren: "./Orders/courier-tracking/courier-tracking.module#CourierTrackingModule", },
  //end
  //added by vithujan 25-01-2024 - Siddarth
  { path: "bid-pickup-request", component: BidTransporterPickupRequestComponent, },
  { path: "Internetconnectivity", component: InternetconnectivityComponent },
  { path: "NewLogin", loadChildren: "./theme/NewLogin/newloginpage/newloginpage.module#NewloginpageModule", },
  { path: "reset-password-new", loadChildren: "./theme/NewLogin/newloginpage/newloginpage.module#NewloginpageModule", },
  { path: "trip-planning-map", loadChildren: "./trip-planning-map/trip-panning-map.module#TripPlanningMapModule", },
  {
    path: "Newtracking",
    loadChildren: "./newDesign/new-tracking/new-tracking.module#NewTrackingModule",
  },
  {
    path: "TermsConditions",
    loadChildren: "./new-terms-conditions/new-terms-conditions.module#NewTermsConditionsModule",
  },
  {
    path: "PrivacyPolicy",
    loadChildren: "./newprivacy-policy/newprivacy-policy.module#NewprivacyPolicyModule",
  },
  { path: 'ssologin', 'component': SsologinComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
